import { EventEmitter, Injectable } from '@angular/core';

@Injectable()
export class PushNotificationsService {

  openPushNotificationModal = new EventEmitter();

  constructor() { }

}